import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-policy-svg',
  template: `
  <div class="svg-container">
<svg height="90px" width="68px" viewBox="0 0 68 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
<desc>Created with Sketch.</desc>
<defs></defs>
<g id="OB-03:-Add-policy-(manually)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="OB-03:-Add-policy-(manually)-(C)" transform="translate(-154.000000, -107.000000)">
        <g id="09_ITEM/Hero/Policy_Generic" transform="translate(140.000000, 104.000000)">
            <g id="Group" transform="translate(14.000000, 3.000000)">
                <rect id="Rectangle" stroke="#737373" stroke-width="3" fill="#FFFFFF" fill-rule="nonzero" x="1.5" y="1.5" width="65" height="87"></rect>
                <circle id="Oval" fill="#737373" fill-rule="nonzero" cx="34" cy="32" r="14"></circle>
                <polygon id="long-line" fill="#737373" fill-rule="nonzero" points="17 52 17 54.1818182 51.2486486 54.1818182 51.2486486 52"></polygon>
                <polygon id="mid-line" fill="#737373" fill-rule="nonzero" points="19 60 19 62.1818182 49 62.1818182 49 60"></polygon>
                <polygon id="short-line" fill="#737373" fill-rule="nonzero" points="22 67 22 69.1818182 47 69.1818182 47 67"></polygon>
                <polyline id="Fill-14" fill="#FFFFFE" points="34.4996479 32.5005616 31.5142247 26 27 26 27 39 31.5142247 39 31.5142247 32.5005616 34.4996479 39 37.4850711 32.5005616 37.4850711 39 42 39 42 26 37.4850711 26 34.4996479 32.5005616"></polyline>
            </g>
        </g>
    </g>
</g>
</svg></div>`
})
export class PolicySvgComponent {}
